import { render, staticRenderFns } from "./vSelect2.vue?vue&type=template&id=1127e776"
import script from "./vSelect2.vue?vue&type=script&lang=ts"
export * from "./vSelect2.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports